// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"modalFooter__wrapper","item":"modalFooter__item"};